module.exports = __webpack_public_path__ + "images/ed0f68250c5d75c3aa3360bdfe379b33-illu_newBox_SmokeHeatSensor.png";